import { Button, Grid } from '@mui/material';
import { RightDrawer, Spacer, Row, Column } from '../../../components';
import OutstandingInvoice from './OutstandingInvoice';
import AutoPayDetails from './AutoPayDetails';
import SubscriptionDetails from './SubscriptionDetails';
import { PaymentMethodData } from '../../../api/apis/AdminPaymentApi';
import { LicenseAgreementData } from '../../../api/apis/LicenseAgreementApi';
import AutoPayAgreement from './AutoPayAgreement';
import { InvoiceData, InvoiceStatusEnum } from '../../../api/apis/InvoiceApi';
import { useEffect, useState } from 'react';

interface AutoPayDrawerProps {
  drawerOpen: boolean;
  setDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
  invoices: InvoiceData[] | undefined;
  invoiceTotal: number | undefined;
  invoiceTotalLoading?: boolean;
  activeOrgPricebooks: LicenseAgreementData[] | undefined;
  defaultPaymentMethod: PaymentMethodData | undefined;
  handleSubmit: () => void;
  submitting?: boolean;
}

const AutoPayDrawer: React.FC<AutoPayDrawerProps> = ({
  drawerOpen,
  setDrawerOpen,
  invoices,
  invoiceTotal,
  invoiceTotalLoading,
  activeOrgPricebooks,
  defaultPaymentMethod,
  handleSubmit,
  submitting,
}) => {
  const hasOutstanding =
    (invoices && invoices?.some(invoice => invoice.status === InvoiceStatusEnum.Open)) ?? false;
  const hasActivePricebooks = (activeOrgPricebooks?.length ?? 0) > 0;
  const outstandingTotalUnavailable = hasOutstanding && invoiceTotal === undefined;
  const [checked, setChecked] = useState<boolean>(false);

  useEffect(() => {
    if (!drawerOpen) setChecked(false);
  }, [drawerOpen]);

  return (
    <RightDrawer open={drawerOpen} setOpen={setDrawerOpen} title='Set up auto-pay?'>
      <Grid container flexDirection='column' margin='5px 0px 0px 10px'>
        <AutoPayDetails hasOutstanding={hasOutstanding} />
        <Spacer height='sm' />
        <Row style={{ justifyContent: 'center' }}>
          <Column style={{ alignItems: 'center' }}>
            {hasOutstanding && (
              <>
                <OutstandingInvoice invoiceTotal={invoiceTotal} loading={invoiceTotalLoading} />
                <Spacer height='md' />
              </>
            )}
            {hasActivePricebooks && (
              <>
                <SubscriptionDetails
                  activeOrgPricebooks={activeOrgPricebooks}
                  defaultPaymentMethod={defaultPaymentMethod}
                />
                <Spacer height='sm' />
              </>
            )}
            <AutoPayAgreement setChecked={setChecked} />
          </Column>
        </Row>
        <Spacer height='lg' />

        <Row style={{ justifyContent: 'space-between' }}>
          <Button color='secondary' variant='outlined' onClick={() => setDrawerOpen(false)}>
            Close
          </Button>
          <Button
            color='primary'
            loading={submitting}
            disabled={!checked || outstandingTotalUnavailable}
            onClick={handleSubmit}>
            Set up auto-pay
          </Button>
        </Row>
      </Grid>
    </RightDrawer>
  );
};

export default AutoPayDrawer;
